import { ObjectSchema, object, string, number } from 'yup';
import { noop } from '@utils/noop';
import { Dispatch, createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import * as Yup from 'yup';

export type TestsFormState = {
  url: string;
  currency: string;
  amount: number;
};

export const testsFormStateDefault: TestsFormState = {
  url: '',
  currency: '',
  amount: 0,
};

export const testsSchemaDefault: ObjectSchema<Partial<TestsFormState>> = object<
  Partial<TestsFormState>
>().shape({
  url: Yup.string()
    .test(
      'not-empty-or-spaces',
      'url can not be empty or just spaces',
      (value) => !!value && value.trim().length > 0
    )
    .min(2, 'url must be at least 2 characters')
    .required('url is a required field'),

  currency: string().required('currency is required field'),
  amount: number().required('amount is required field'),
});

type TestsFormContextType = {
  schema: ObjectSchema<Partial<TestsFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<TestsFormState>>>;
  methods?: UseFormReturn<TestsFormState>;
};

const testsFormContextDefault = {
  schema: testsSchemaDefault,
  setSchema: noop,
} satisfies TestsFormContextType;

export const TestsFormContext = createContext<TestsFormContextType>(testsFormContextDefault);

export const useTestsForm = () => {
  const { methods } = useContext(TestsFormContext);
  if (!methods) {
    throw new Error('TestsFormContext is empty');
  }

  return methods;
};

export const useManageTestsSchema = () => {
  const { setSchema } = useContext(TestsFormContext);

  return { setSchema };
};
